import React, {Component} from "react"
import styled from "styled-components"

import Form from "@irati/ui/src/Form"
import {Para} from "@irati/ui/src/Labels"
import {Email} from "@irati-web/fields/user"
import {FormattedMessage} from "@irati/utils/lang"

import ContinueBackButtons from "../ContinueBackButtons"
import {GET_STARTED, SET_PROFILE_INFO} from "../../containers/Home/GetStarted"

const Description = styled(Para)`
  text-align: center;
  margin-bottom: 30px;
`

const Content = styled.div`
  max-width: 360px;
  margin: 0 auto;
`

interface Props {
  email: string,
  onUpdateEmail: (email: string) => void,
  onUpdateStep: (step: string) => void
}

class EmailStep extends Component<Props> {
  render() {
    const {email, onUpdateEmail, onUpdateStep} = this.props
    return (
      <Form>
        <Description large><FormattedMessage id="medical.landing.steps.email.desc" /></Description>
        <Content>
          <Email label="" value={email} onChange={onUpdateEmail} />
          <Para light narrow><FormattedMessage id="medical.landing.steps.email.para" /></Para>
          <ContinueBackButtons
            onBack={() => onUpdateStep(GET_STARTED)}
            onContinue={() => onUpdateStep(SET_PROFILE_INFO)} />
        </Content>
      </Form>
    )
  }
}

export default EmailStep
